import {
  Anchor,
  AnchorProps,
  Avatar,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Flex,
  SimpleGrid,
  Text,
} from "@govlaunch/web";
import Box from "@govlaunch/web/src/box/Box";
import React, { ReactNode } from "react";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import { SimilarProductsCardIcon } from "./icons";
import { FormattedMessage } from "react-intl";

interface IProductAlternativesCardProps extends AnchorProps {
  product: IProductFieldsFragment;
  renderLinkWrap?: (product: NonNullable<IProductFieldsFragment["alternatives"]>[0], children: ReactNode) => ReactNode;
}

export default function ProductAlternativesCard({ product, renderLinkWrap }: IProductAlternativesCardProps) {
  if (!product.alternatives || product.alternatives.length === 0) {
    return null;
  }

  return (
    <Card mt={4}>
      <CardHeader>
        <SimilarProductsCardIcon />

        <CardTitle>
          <FormattedMessage defaultMessage="Similar Products" id="ru28zW" />
        </CardTitle>
      </CardHeader>

      <CardBody>
        <SimpleGrid gridRowGap={4}>
          {product.alternatives.map(product => {
            const anchor = (
              <Anchor key={product._id} href={`https://govlaunch.com/products/${product.slug}`}>
                <Flex alignItems="center">
                  <Avatar src={product.logo} name={product.name} size="md" />

                  <Box ml={4}>
                    <Text fontSize="sm" color="gray.600" fontWeight="semibold">
                      {product.name}
                    </Text>
                  </Box>
                </Flex>
              </Anchor>
            );

            return renderLinkWrap ? renderLinkWrap(product, anchor) : anchor;
          })}
        </SimpleGrid>
      </CardBody>
    </Card>
  );
}
